import { Stack, TextInput } from "@mantine/core";
import { ProductCategoryRequestBodyType } from "constants/types/productCategory";
import { FormikProps } from "formik";
import { FC } from "react";

interface ProductCategoryFormFieldsProps {
  formik: FormikProps<ProductCategoryRequestBodyType>;
}

const ProductCategoryFormFields: FC<ProductCategoryFormFieldsProps> = ({ formik }) => {
  const getFieldError = (field: keyof ProductCategoryRequestBodyType) =>
    formik.touched[field] && formik.errors[field]
      ? (formik.errors[field] as string)
      : undefined;

  return (
    <Stack gap="sm">
      <TextInput
        label="Mã nhóm mặt hàng"
        placeholder="Nhập mã nhóm mặt hàng"
        {...formik.getFieldProps("code")}
        error={getFieldError("code")}
      />
      <TextInput
        label="Tên nhóm mặt hàng"
        placeholder="Nhập tên nhóm mặt hàng"
        withAsterisk
        {...formik.getFieldProps("name")}
        error={getFieldError("name")}
      />
    </Stack>
  );
};

export default ProductCategoryFormFields;
